import React from "react"
const Store = (language = "id") => {

    const store = [
        {
            name: "Rud Runner Surapati Bandung",
            phone: "0822-4047-1861",
            city: "Bandung",
            address: language === "id" ? "Jl. Surapati No. 61, Bandung" : "Jl. Surapati No. 61, Kota Bandung",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3960.9297822834455!2d107.6211331!3d-6.8990016!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e68e7b14ffffffb%3A0x680778656c089b74!2sRud%20Runner%20Surapati%20(Toko%20Sepatu%20Lari%20Bandung)!5e0!3m2!1sid!2sid!4v1767756675840!5m2!1sid!2sid"
        },
        {
            name: "Rud Runner Mall Kelapa Gading Jakarta",
            city: "Jakarta",
            phone: "0821-1704-5002",
            address: language === "id" ? "Mall Kelapa Gading 2, Jl. Boulevard Raya Unit 232 B No.13 No. 1F, Jakarta Utara" : "Mall Kelapa Gading 2, Jl. Boulevard Raya Units 232 B No.13 No. 1F, Jakarta Utara",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15867.233622046577!2d106.89107063143321!3d-6.156409748538441!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f5cea02715f7%3A0x5c647b108112c3c8!2sRud%20Runner%20Mall%20Kelapa%20Gading%20(Toko%20Sepatu%20Lari%20Jakarta)!5e0!3m2!1sid!2sid!4v1767757142719!5m2!1sid!2sid"
        },
        {
            name: "Rud Runner Pantai Indah Kapuk Jakarta",
            city: "Jakarta",
            phone: "0811-1001-0652",
            address: language === "id" ? "Jl. Pantai Indah Kapuk Boulevard, Jakarta Utara" : "Jl. Pantai Indah Kapuk Boulevard, Jakarta Utara",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1015593.5529590856!2d105.58665084687499!3d-6.108835799999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e6a1d3dd159b039%3A0x8be28ca3ab03de89!2sRud%20Runner%20PIK%20Avenue!5e0!3m2!1sid!2sid!4v1767757024420!5m2!1sid!2sid"
        },
        {
            name: "Rud Runner Renon Bali",
            city: "Bali",
            phone: "0813-221-4202",
            address: language === "id" ? "Jl. Cut Nyak Dien Ruko B No.1, Kota Denpasar, Bali" : "Jl. Cut Nyak Dien Ruko B No.1, Kota Denpasar, Bali",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d16155560.559608052!2d96.77229645!3d-8.669792300000006!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2dd2418cf32fbc4d%3A0xb24c9e273dfd83b!2sRud%20Runner%20Renon%20(Toko%20Sepatu%20Lari%20Bali)!5e0!3m2!1sid!2sid!4v1773114416393!5m2!1sid!2sid"
        },
    ];

    return store;
};
export default Store;